function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  value = encodeURIComponent(value);

  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}


module.exports = {
  updateQueryStringParameter: updateQueryStringParameter
};


//////////////////
// WEBPACK FOOTER
// ./joor_modules/helpers/uri.js
// module id = 20
// module chunks = 5